<template>
  <div class="home legal">
    <div class="header d-none d-sm-block">
      <FloatingLogo></FloatingLogo>
      <div class="header-slider"></div>
    </div>

    <div class="header mobile d-xs-block d-sm-none">
      <FloatingLogo></FloatingLogo>
      <div class="header-slider"></div>
    </div>

    <div class="body text-left">
      <div class="boxed container">
        <div class="title">
          <h2>Acuerdo de Términos y Condiciones</h2>
        </div>
        <div class="content card-like">
            <LegalContents />
        </div>
      </div>

      <div class="bottom-spacer"></div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
  import Footer from "@/components/Footer";
  import LegalContents from "../components/LegalContents";
  import FloatingLogo from "../components/FloatingLogo";
  export default {
    name: "Legal",
    components: {
      FloatingLogo,
      LegalContents,
      Footer
      // HelloWorld
    }
  };
</script>
